import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import Select from "react-select"
import API from "../../../api"
import {
  Col,
  Input,
  Row,
  Label,
  Form,
  Table,
  Card,
  CardBody,
  CardTitle,
  Container,
  Spinner,
} from "reactstrap"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const DetailFactBlClient = props => {
  var userAuth = JSON.parse(localStorage.getItem("userAuth"))
  const user_id = userAuth.user.id
  //
  const [loading, setLoading] = useState(false)
  const [numFact, setNumFact] = useState("")
  const [dateFact, setDateFact] = useState(new Date())
  const [selectCodeClient, setSelectCodeClient] = useState("")
  const [raisonSocial, setRaisonSocial] = useState("")
  const [adresse, setAdresse] = useState("")
  const [selectFamilleClient, setSelectFamilleClient] = useState("")
  const [etatFodec, setEtatFodec] = useState(0)
  const [codeTva, setCodeTva] = useState("")
  const [remiseExcep, setRemiseExcep] = useState("")
  const [selectRepre, setSelectRepre] = useState("")
  const [etatRegimeForf, setEtatRegimeForf] = useState(0)
  const [selectModeRegl, setSelectModeRegl] = useState("")
  const [arrayProduit, setArrayProduit] = useState([])
  const [array, setArray] = useState([])
  const [totalHT, setTotalHT] = useState("")
  const [totalTTC, setTotalTTC] = useState("")
  const [totalTva, setTotalTva] = useState("")
  const [totalRemise, setTotalRemise] = useState("")
  const [totalFodec, setTotalFodec] = useState("")

  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    const res = await API.post("facture/client/getByIdLiv", {
      id,
    }).then(res => {
      setNumFact(res.data.FactureClient.num_fact)
      setDateFact(new Date(res.data.FactureClient.date_fact))
      setSelectCodeClient(res.data.FactureClient.client_id)
      setRaisonSocial(res.data.FactureClient.raisonSocial)
      setAdresse(res.data.FactureClient.adresse)
      setSelectFamilleClient(res.data.FactureClient.famille_client_id)
      setEtatFodec(res.data.FactureClient.fodec)
      setCodeTva(res.data.FactureClient.codeTva)
      setRemiseExcep(res.data.FactureClient.remise_excep)
      setSelectRepre(res.data.FactureClient.representant_id)
      setEtatRegimeForf(res.data.FactureClient.regimeForfitaire)
      setSelectModeRegl(res.data.FactureClient.mode_reglement_id)
      setArrayProduit(res.data.FactureClient.ligne)
      setTotalHT(res.data.FactureClient.total_ht)
      setTotalTTC(res.data.FactureClient.total_ttc)
      setTotalTva(res.data.FactureClient.total_tva)
      setTotalRemise(res.data.FactureClient.total_remise)
      setTotalFodec(res.data.FactureClient.total_fodec)
      setArray(res.data.FactureClient.array_id_livraison)
      setLoading(true)
    })
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {loading ? (
            <Row>
              <CardTitle className="h4 mb-4" style={{ color: "#556ee6" }}>
                Consultation facture BL client
              </CardTitle>
              <Form>
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        N° facture BL
                      </Label>
                      <Input
                        lg="3"
                        type="text"
                        className="form-control"
                        disabled
                        value={numFact}
                      />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        Date facture BL
                      </Label>
                      <Col md={12} className="pr-0">
                        <DatePicker
                          className="form-control ddate"
                          selected={dateFact}
                          dateFormat="dd/MM/yyyy"
                          disabled
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Client
                        <span style={{ color: "red", paddingLeft: "5px" }}>
                          *
                        </span>
                      </Label>
                      <Select
                        isSearchable={true}
                        value={selectCodeClient}
                        isDisabled
                      />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        Raison sociale
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Raison sociale"
                        value={raisonSocial}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">Adresse</Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Adresse"
                        value={adresse}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">Famille</Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Famille"
                        value={selectFamilleClient.label}
                        disabled
                      />
                    </div>
                  </Col>
                 {/* <Col md={3}>
                    <div className="mb-3 mt-3">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          className="form-check-Input"
                          id="horizontal-customCheck"
                          checked={etatFodec == 1}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="horizontal-customCheck"
                        >
                          Fodec
                        </Label>
                      </div>
                    </div>
          </Col>*/}
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">Code TVA</Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Code TVA"
                        value={codeTva}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        Representant
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Representant"
                        value={selectRepre.label}
                        disabled
                      />
                    </div>
                  </Col>
                  {/*<Col md={3}>
                    <div className="mb-3 mt-3">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          className="form-check-Input"
                          id="horizontal-customCheck"
                          checked={etatRegimeForf == 1}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="horizontal-customCheck"
                        >
                          Régime forfaitaire
                        </Label>
                      </div>
                    </div>
          </Col>*/}
                  <Col md={3}>
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        Mode reglement
                      </Label>
                      <Select
                        isSearchable={true}
                        value={selectModeRegl}
                        isDisabled
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
              <Fragment>
                <div className="row mt-4">
                  <table
                    style={{ marginTop: "10px" }}
                    className="table table-bordered"
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }} scope="col">
                          Numéro piéce
                        </th>
                        <th style={{ textAlign: "center" }} scope="col">
                          Date piéce
                        </th>
                        <th style={{ textAlign: "center" }} scope="col">
                          Montant TTC
                        </th>
                        <th style={{ textAlign: "center" }} scope="col">
                          Facturation
                        </th>
                      </tr>
                    </thead>
                    {arrayProduit.map((el, index) => (
                      <tbody key={index}>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            <p
                              style={{
                                textAlign: "center",
                                borderRadius: "5px",
                              }}
                            >
                              {el.numBonLiv}
                            </p>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <p
                              style={{
                                textAlign: "center",
                                borderRadius: "5px",
                              }}
                            >
                              {el.dateBonLiv}
                            </p>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <p
                              style={{
                                textAlign: "center",
                                borderRadius: "5px",
                              }}
                            >
                              {el.mntTtc}
                            </p>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <label style={{ paddingRight: "10px" }}>
                              {" "}
                              Facturer
                            </label>
                            <Input
                              type="checkbox"
                              className="form-check-Input"
                              checked={el.etat}
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
                <Fragment>
                  <Card>
                    <CardBody>
                      <CardTitle className="mb-3">Total </CardTitle>
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <td>Total des remises :</td>
                              <td style={{ fontWeight: "bold" }}>
                                {totalRemise}
                              </td>
                            </tr>
                            <tr>
                              <td>Total HT :</td>
                              <td style={{ fontWeight: "bold" }}>{totalHT}</td>
                            </tr>
                            <tr>
                              <td>Total fodec :</td>
                              <td style={{ fontWeight: "bold" }}>
                                {totalFodec}
                              </td>
                            </tr>
                            <tr>
                              <td>Total TVA :</td>
                              <td style={{ fontWeight: "bold" }}>{totalTva}</td>
                            </tr>
                            <tr>
                              <td>Avance/Impot :</td>
                              <td style={{ fontWeight: "bold" }}>{""}</td>
                            </tr>
                            <tr>
                              <td>Total TTC : </td>
                              <td style={{ fontWeight: "bold" }}>{totalTTC}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Fragment>
              </Fragment>
            </Row>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                <Spinner type="grow" className="ms-6" color="primary" />
              </div>
              <h4
                style={{ textAlign: "center", marginTop: "2%" }}
                className="ms-6"
              >
                {" "}
                Chargement en cours ...
              </h4>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DetailFactBlClient
DetailFactBlClient.propTypes = {
  history: PropTypes.object,
}
